import { FC } from "react"
import { IContainerActionAttributes } from "../../../base/models"
import { PageAction } from "./PageAction"

export const ViewActionCollection: FC<IContainerActionAttributes> = ({ actions }) => {
    if (!actions) return <></>

    return <>
        {actions.slice()
            .sort((a, b) => a.sequence - b.sequence)
            .map((action) => <PageAction
                key={action.actionId}
                action={action}
                onDesignChange={() => { }} />
            )}
    </>
}
